import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import SanctuaryHeader from "@/components/gateway/SanctuaryHeader";
import FrequencyPlayer from "@/components/tools/FrequencyPlayer";
import MeditationPlayer from "@/components/tools/MeditationPlayer";
import { ArrowLeft, Music, Waves } from "lucide-react";

const Sounds = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [tools, setTools] = useState([]);

  useEffect(() => { api.get("/public/tools").then(({ data }) => setTools(data)).catch(() => {}); }, []);

  const freq = tools.find((t) => t.type === "frequencies");
  const med = tools.find((t) => t.type === "meditation");

  return (
    <div className="min-h-screen px-5 py-6 relative"
      style={{ background: "radial-gradient(ellipse at 50% 15%, #16302a 0%, #0f2019 55%, #0a1410 100%)" }}
      data-testid="sounds-screen">

      <SanctuaryHeader tone="dark" className="absolute top-5 left-5 z-20" />

      <button onClick={() => navigate(user ? "/app/tools" : "/gateway")} data-testid="sounds-back"
        className="absolute top-5 right-5 flex items-center gap-2 text-white/40 hover:text-white/80 text-xs transition-colors">
        <ArrowLeft className="w-4 h-4" /> Back
      </button>

      <div className="max-w-lg mx-auto pt-12">
        <h1 className="font-serif text-4xl text-white text-center">Sound Sanctuary</h1>
        <p className="text-white/50 text-center mt-2 mb-8 font-light">
          Free to explore — Solfeggio healing frequencies and binaural meditation tones. Use gentle volume and headphones.
        </p>

        {freq && (
          <div className="rounded-3xl border border-white/12 bg-white/5 backdrop-blur-md p-5 mb-5" data-testid="sounds-frequencies">
            <p className="flex items-center gap-2 text-white/85 mb-1"><Music className="w-4 h-4 text-teal-200" /> {freq.title}</p>
            <p className="text-white/45 text-sm mb-3">{freq.summary}</p>
            <div className="text-white/85"><FrequencyPlayer frequencies={freq.frequencies} /></div>
          </div>
        )}

        {med && (
          <div className="rounded-3xl border border-white/12 bg-white/5 backdrop-blur-md p-5" data-testid="sounds-meditation">
            <p className="flex items-center gap-2 text-white/85 mb-1"><Waves className="w-4 h-4 text-teal-200" /> {med.title}</p>
            <p className="text-white/45 text-sm mb-3">{med.summary}</p>
            <div className="text-white/85"><MeditationPlayer states={med.states} /></div>
          </div>
        )}

        {!user && (
          <div className="mt-8 text-center">
            <p className="text-white/45 text-sm mb-3">Create a free account to save reflections and unlock your full toolkit.</p>
            <button onClick={() => navigate("/register")} data-testid="sounds-signup"
              className="rounded-full px-6 py-3 bg-teal-200/15 border border-teal-200/30 text-white hover:bg-teal-200/25 transition-colors">
              Create your sanctuary
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sounds;
